import * as classNames from "classNames";
import * as React from "react";
import { ITableConfig } from "../Table";
import { getValueByKey } from "../Utils/TableUtils";

export interface ITableCellProps {
    i: number;
    rowIndex: number;
    data: any;
    config: ITableConfig;
    tdCssWrapper?: string;
}

export const TableCell = (props: ITableCellProps) => {
    return (
        <td
            key={`table-data-${props.i}`}
            onClick={(e) => {
                e.stopPropagation();
                props.config.onClick
                    ? props.config.onClick(getValueByKey(props.data, props.config.key), props.data, props.rowIndex)
                    : {};
            }}
            className={props.config.tdCssWrapper}
        >
            {props.config.render
                ? props.config.render(getValueByKey(props.data, props.config.key), props.data, props.rowIndex)
                : getValueByKey(props.data, props.config.key)}
        </td>
    );
};
